
import { getCookie, setCookie } from '~/utils/index'

export default {
  data() {
    return {
      show: false,
      doNotShowToday: false,
    }
  },
 mounted() {
    const isHome = this.$route.path === '/'  // 또는 this.$route.name === 'home' 으로도 가능
    const hide = getCookie('hideNoticePopup')

    if (isHome && !hide) {
      this.show = true
    }
  },
  methods: {
    onClose() {
      if (this.doNotShowToday) {
        setCookie('hideNoticePopup', '1', 7) // 일주일 동안 보지 않기
      }
      this.show = false
    }
  }
}
